import styled from '@emotion/styled';
import { theme } from '../../../theme';
export const ToggleCircle = styled.span `
	position: absolute;
	top: 3px;
	left: 3px;
	border-radius: 50%;
	background-color: #FFFFFF;
	transition: transform 0.3s;
	box-shadow: 0px 1px 4px rgba(10, 24, 43, 0.05), 0px 2px 8px rgba(10, 24, 43, 0.08);
	cursor: pointer;

	${({ toggled }) => !toggled && 'padding: 12px'};
`;
export const CheckboxContainer = styled.span `
	width: 52px;
	height: 32px;
	background-color: ${({ toggled, toggledColor }) => toggled ? toggledColor : theme.colors.LM_NU10};
	position: relative;
	border-radius: 100px;
	border: 1px solid ${theme.colors.LM_NU30};
	transition: background-color 0.3s;
	${({ focussed }) => focussed && `border: 2px solid ${theme.colors.BB80}`};
`;
export const StyledCheckbox = styled.input `
	width: 100%;
	height: 100%;
	margin: 0;
	position: absolute;
	left: 0;
	opacity: 0;
	border-radius: 100px;
	z-index: 1;
	cursor: pointer;
	:focus, :focus-visible {
		outline: none;
		+ span.circle {
			top: 2px;
			left: 2px;
		}
	}

	:checked {
		+ span.circle {
			transform: translateX(20px);
		}
	}

`;
export const Container = styled.div `
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: ${theme.spacing.space20}
`;
export const TextContainer = styled.div `
	flex: 1;
`;
export const Label = styled.label `
	font-family: ${theme.typography.IB100.fontFamily};
	font-weight: ${theme.typography.IB100.fontWeight};
	font-size: ${theme.typography.IB100.fontSize};
	letter-spacing: ${theme.typography.IB100.letterSpacing};
	color: ${theme.colors.typography.label};
	line-height: 150%;

	cursor: pointer;
	width: 100%;
	display: block;
`;
export const SupportText = styled.span `
	display: block;
	font-family: ${theme.typography.IR90.fontFamily};
	font-weight: ${theme.typography.IR90.fontWeight};
	font-size: ${theme.typography.IR90.fontSize};
	letter-spacing: ${theme.typography.IR90.letterSpacing};
	color: ${theme.colors.typography.body};
	line-height: 150%;
`;
//# sourceMappingURL=Switch.styled.js.map